var tdaCodeForDealerSearch = '';
var zipCodeForDealerSearch = '';

define('components/dealer-panel',[
  'jquery',
  'webStorage',
  'lib/util/tda.config',
  'lib/util/zip',
  'lib/getParameterByName',
  'zipTools',
  'cookies',
  'lib/readable-monetize',

  // side effect includes
  'bat',
  'Handlebars',
  'h5validate',
  'dropkick'
], function (
  $,
  WebStorage,
  tdaConfig,
  zip,
  getParameterByName,
  zipTools,
  cookies,
  readableMonetize
) {
  var DealerPanel = function DealerPanel(args) {
    this.$form = args.$form; // the form jQuery Selector
    this.$selectSearchType = args.$selectSearchType; // the form Select box that filters search type.
    this.$inputText = args.$inputText; // the form search text field
    this.$submit = args.$submit; // form submit button
    this.$resultsContainer = args.$resultsContainer; // container where search results are rendered
    this.panelSearch = args.panelSearch; // Panel mode, if true displays PMA as single result.
    this.maxResults = args.maxResults;
    this.autoSearch = args.autoSearch; // form submit button
    this.displayDealerCode = args.displayDealerCode; // display a single dealer instead of a search form
    this.withinTDACode = args.withinTDACode; // include tdacode in service calls
    this.skipGlobalChangeZip = args.skipGlobalChangeZip;
    this.zipRedirectPath = args.zipRedirectPath;
    this.onSearchComplete = args.onSearchComplete; // search complete function, triggered when search is complete.
    this.$searchMoreBtn = args.$searchMoreBtn; // searchMoreButton
    this.$searchLessBtn = args.$searchLessBtn; // searchMoreButton
    this.$slpUserForm = args.$slpUserForm; // used by SLP pages, jquery selector of the SLP form in use
    this.init();
  };

  // Instance methods
  // BEGIN DealerPanel prototype
  DealerPanel.prototype = {
    searchType: 'zip',
    service: {
      deep: {
        url: '/BATWS/geo/rest/searchMode/getDealerDetails', // modified if deep type is dealerName
        params: {
          begin: self.currentResultNum,
          end: self.resultEndNum,
          mirai: false
        }
      },
      zip: {
        url: '/BATWS/geo/rest/searchMode/getDealerDetails',
        params: {
          begin: self.currentResultNum,
          end: self.resultEndNum,
          mirai: false
        }
      },
      state: {
        url: '/BATWS/geo/rest/searchMode/getDealerDetails',
        params: {
          begin: self.currentResultNum,
          end: self.resultEndNum,
          mirai: false
        }
      },
      dealerName: {
        url: '/BATWS/geo/rest/filterMode/getDealerDetails',
        params: {
          begin: self.currentResultNum,
          end: self.resultEndNum,
          mirai: false
        }
      }
    },

    initSetSearchType: function (searchType) {
      var self = this;
      switch (searchType) {
        case 'zip':
          self.searchType = 'zip';
          self.service.zip.params.begin = self.currentResultNum;
          self.service.zip.params.end = self.maxResults;
          self.service.zip.params.zipcode = self.$inputText.val();
          self.service.zip.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          if (self.service.zip.params.zipcode == '') {
            self.service.zip.params.zipcode = zip.getCookiedDefaultFallback();
          }
          if (self.withinTDACode) {
            self.service.zip.params.tdacode = self.withinTDACode;
          } else {
            var tdaCodeFromParam = getParameterByName('tdaCode');
            if (tdaCodeFromParam) {
              self.service.zip.params.tdacode = tdaCodeFromParam;
            }
          }

          self.serviceUrl = self.service.zip.url;
          self.serviceParams = self.service.zip.params;
          self.validationVals = 'numbers';
          self.deepLinkHash = {
            type: 'zip',
            end: self.currentResultNum,
            query: self.service.zip.params.zipcode,
            queryText: ''
          };
          break;

        case 'state':
          self.searchType = 'state';
          // self.service.state.params.brandId = self.currentResultNum;
          self.service.state.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.service.state.params.searchMode = 'proximityOnly';
          self.service.state.params.proximityMode = 'expandingRadius';
          self.service.state.params.resultsMode = 'starOnly';
          self.service.state.params.begin = self.currentResultNum;
          self.service.state.params.end = self.maxResults;
          self.serviceUrl = self.service.state.url;
          self.serviceParams = self.service.state.params;
          self.validationVals = 'all';
          self.deepLinkHash = {
            type: 'state',
            end: self.currentResultNum,
            query: '', // will be populated with zipcode, default to empty
            queryText: '' // will be populate w/ val from input
          };
          break;
        case 'dealerName':
          self.searchType = 'dealerName';
          self.service.dealerName.params.begin = self.currentResultNum;
          self.service.dealerName.params.end = self.maxResults;
          self.service.dealerName.params.dealerName = self.$inputText.val();
          self.service.dealerName.params.tdacode = localStorage.tdaCode;
          self.service.dealerName.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.serviceUrl = self.service.dealerName.url;
          self.serviceParams = self.service.dealerName.params;
          self.validationVals = 'none';
          self.deepLinkHash = {
            type: 'dealerName',
            end: self.currentResultNum,
            query: self.service.dealerName.params.dealerName,
            queryText: ''
          };
          break;
        case 'deep':
          self.deepLinkHash = {}; // if this is a deep link search, read the hash from our cookie
          var deepLinkHashFromCookie = JSON.parse(cookies.getItem('dealerSearchDeep'));
          // update each property of our exisiting deepLinkHash with those from cookie
          self.deepLinkHash.end = deepLinkHashFromCookie.end; // store the hash on this search
          self.deepLinkHash.query = deepLinkHashFromCookie.query; // store the hash on this search
          self.deepLinkHash.type = deepLinkHashFromCookie.type; // store the hash on this search
          self.deepLinkHash.queryText = deepLinkHashFromCookie.queryText; // store the hash on this search

          var deepEnd = self.deepLinkHash.end || 5;
          var deepQuery = self.deepLinkHash.query || self.$inputText.val();
          var deepType = self.deepLinkHash.type || 'zip';

          // default params
          self.searchType = 'deep'; // 'Local'
          self.service.deep.params.begin = self.currentResultNum;
          self.service.deep.params.end = deepEnd;
          self.service.deep.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.serviceUrl = self.service.deep.url; // default service URL

          // zip specific params
          if (deepType === 'zip') {
            self.service.deep.params.zipcode = deepQuery;

          // dealerName specific params
          } else if (deepType === 'dealerName') {
            self.serviceUrl = self.service.dealerName.url; // update service URL to use that from dealerName
            self.service.deep.params.dealerName = deepQuery;
            self.service.deep.params.tdacode = localStorage.tdaCode;

          // state specific params
          } else if (deepType === 'state') {
            self.service.deep.params.searchMode = 'proximityOnly';
            self.service.deep.params.proximityMode = 'expandingRadius';
            self.service.deep.params.resultsMode = 'starOnly';
            self.service.deep.params.zipcode = deepQuery; // state search ultimately just use a zipcode
          }
          self.serviceParams = self.service.deep.params;
          break;
        default: break;
      }
    },

    init: function () {
      var self = this;
      self.searchCount = 1;
      self.currentResultNum = 1;
      self.resultEndNum = self.maxResults;
      self.deepLinkHash = {};
      var preURL = window.location.pathname.split('/');
      var tempZip = preURL.pop();
      var dealerDirectoryZip = preURL.pop();

      if ((window.location.pathname.indexOf('dealer-directory')) && (dealerDirectoryZip > 0)) {
        // console.log("Set zip and confirmed zip");
        zipTools.changeZip(zip.getCookiedDefaultFallback(), dealerDirectoryZip, '', function (newZip) {
          var $noDealersText = $('#no-dealers-found', self.$form);
          if ($noDealersText.is(':visible')) {
            $noDealersText.hide();
          }
          self.$form.addClass('is-loading');
          if (self.panelSearch) {
            self.dealerSearch();
          }
        });
      }

      if (cookies.getItem('isConfirmedZip') !== 'true' || $('#dealer-results input:radio[name=pma]:checked').val() == undefined || $('#dealer-results input:radio[name=pma]:checked').val() == null) {
        $('#slp-submit-button').addClass('hidden');
        // BAT-3146. HIDE THE LOADER FOR PAGES WITHOUT CONFIRMED ZIP. WWW AND TDA'S WILL GET THIS.
        window.bat.util.loader.hideLoader();
        // BAT-3500. Hide loader after modal is dismissed. Show no dealer text
        $('#zip-modal-confirm').on('hide.bs.modal', function () {
          // console.log('modal closing');
          $('#slp-dealer-search').removeClass('is-loading');
          $('#no-dealers-found', self.$form).show();
        });
      }

      $('form').h5Validate({});

      if (this.$searchMoreBtn && this.$searchMoreBtn.length) {
        this.$searchMoreBtn.on('click', function (event) {
          event.preventDefault();
          if (self.$searchMoreBtn.data('pendingSearchData')) {
            // still on first page of results, kind of a hack
            self.currentResultNum = 1;
            self.onSearchComplete(self.$searchMoreBtn.data('pendingSearchData'));
          } else {
            self.begin = self.end + 1;
            self.end = self.begin + self.maxResults;
            self.loadMoreResults(self.begin, self.end);
          }
        });
      }

      if (this.$searchLessBtn && this.$searchLessBtn.length) {
        this.$searchLessBtn.on('click', function (event) {
          event.preventDefault();

          if (self.$searchLessBtn.data('pendingSearchData')) {
            // still on first page of results, kind of a hack
            self.currentResultNum = 1;
            self.onSearchComplete(self.$searchLessBtn.data('pendingSearchData'));
          } else {
            self.end = self.begin - 1;
            // console.log("self end-2", self.end);
            self.begin = self.begin - self.maxResults - 1;
            // console.log("self begin-2", self.begin);
            if (self.begin < 0) {
              self.begin = 0;
            }
            self.loadLessResults(self.begin, self.end);
          }
        });
      }

      // BAT-2723.
      self.isAndroid = $('html').hasClass('android');// ||  $('html').hasClass('firefox');
      self.checkNumbers = function (e) {
        zipTools.numericInput(e, true);
      };
      self.checkNonNumbers = function (e) {
        console.log('checkNonNumbers', e);
        console.log('checkNonNumbers', e.which);
        zipTools.noNumbersInput(e, true);
      };

      // BAT-2723
      self.stripAndroidNumbers = function (str) {
        // RAQ PAGE OR FAD PAGE:
        // var inputfield =  $('#request-a-quote').length ? $('#find-dealer-method') : $('#search-value');
        // var inputfield = $('#dealer-search-page').length ? $('#search-value') : $('#find-dealer-method');
        var inputfield = $('#dealer-search-page').length ? $('.js-search-value:visible') : $('#find-dealer-method'); // BAT-4293
        var current = inputfield.val();
        var stripped = current.replace(/[0-9]/g, '');
        inputfield.val(stripped);
      };

      if (self.$selectSearchType.length > 0) {
        self.$selectSearchType.dropkick({ mobile: false });
        // self.$inputText.attr('pattern', '[0-9]*');

        self.$selectSearchType.on('change', function () {
          var placeholderText = $(this).find(':selected').attr('data-placeholder');
          self.searchType = $(this).val();
          self.initSetSearchType(self.searchType);
          self.$inputText.attr('aria-label', placeholderText);
          self.$inputText.attr('placeholder', placeholderText).val('');

          // remove data-storage attribute if not zip, put it back if zip
          // BAT25-390 The future is coming. Don't do any of this nonsense going fwd. starting with the dealer-search page
          if (!$('#dealer-search-page').length) {
            if (self.searchType === 'zip') {
              self.$inputText.prop('type', 'tel');
              self.$inputText.attr('pattern', '[0-9]*')
                .attr('title', 'Zip Code is required - 5 digits.')
                .data('storage', 'userZip').addClass('h5-zip');
            } else {
              self.$inputText.prop('type', 'text');
              self.$inputText.data('storage', undefined);
              self.$inputText.removeAttr('pattern')
                .removeClass('h5-zip')
                .attr('title', 'City, State');
            }

            if (self.validationVals === 'all') {
              if (self.isAndroid) {
                if ($('#dealer-search-page').length) {
                  // $(document).delegate('#search-value', 'input', self.stripAndroidNumbers);
                  $(document).delegate('.js-search-value:visible', 'input', self.stripAndroidNumbers); // BAT-4293
                } else {
                  $(document).delegate('#find-dealer-method', 'input', self.stripAndroidNumbers);
                }
              } else {
                // prevent numbers from being entered in city/state search
                self.$inputText.off('keydown', null);
                self.$inputText.off('keypress', null);
                self.$inputText.keydown(function (e) {
                  zipTools.cityStateInput(e);
                }).keypress(function (e) {
                  zipTools.cityStateInput(e);
                });
              }
              self.$inputText.removeAttr('maxlength');
            } else if (self.validationVals === 'none') {
              if (self.isAndroid) {
                if ($('#dealer-search-page').length) {
                  // $(document).undelegate('#search-value', 'input');
                  $(document).undelegate('.js-search-value:visible', 'input'); // BAT-4293
                } else {
                  $(document).undelegate('#find-dealer-method', 'input');
                }
              } else {
                self.$inputText.off('keydown', null);
                self.$inputText.off('keypress', null);
                self.$inputText.removeAttr('maxlength');
              }
            } else {
              if (self.isAndroid) {
                if ($('#dealer-search-page').length) {
                  // $(document).undelegate('#search-value', 'input', self.stripAndroidNumbers);
                  $(document).undelegate('.js-search-value:visible', 'input', self.stripAndroidNumbers); // BAT-4293
                } else {
                  $(document).undelegate('#find-dealer-method', 'input', self.stripAndroidNumbers);
                }
              } else {
                // only allow #'s in zip search
                self.$inputText.off('keydown', null);
                self.$inputText.off('keypress', null);
                self.$inputText.keydown(function (e) {
                  zipTools.numericInput(e);
                }).keypress(function (e) {
                  zipTools.numericInput(e);
                });
              }
              self.$inputText.attr('maxlength', 5);
            }
          }
        }); // END self.$selectSearchType.on('change')
      }

      if (self.autoSearch) {
        self.$inputText.addClass('ui-state-valid');
      }

      self.$submit.on('click', function (e) {
        e.preventDefault();
        var $noDealersText = $('#no-dealers-found', self.$form);
        if ($noDealersText.is(':visible')) {
          $noDealersText.hide();
        }

        // BAT-2091 revealed that we were NOT checking for valid dealer-search fields on click
        // zip/state, city / dealer name input MUST be valid to continue
        // if it's NOT valid, we mark the input as such.

        var dealerSearchIsValid = false;
        var dealerSearchType;
        if ($('#dealer-search-page').length > 0) {
          var dealerSearchField = self.$inputText;
          var inlineModal = true;
          dealerSearchType = self.searchType;
          // BAT25-390 change self.searchType to state if self.searchType is zip && input val is not numeric
          if (self.searchType === 'zip' && !$.isNumeric(self.$inputText.val())) {
            self.searchType = 'state';
            dealerSearchType = 'state';
          }
          if (self.searchType === 'state' && $.isNumeric(self.$inputText.val())) {
            self.searchType = 'zip';
            dealerSearchType = 'zip';
          }
          dealerSearchIsValid = dealerSearchField.hasClass('ui-state-valid');
        // SLP forms
        } else {
          var dealerSearchField = $('#find-dealer-method');
          var inlineModal = false;
          dealerSearchType = $('select#search-type').val();
          // select#search-type was removed for BAT-4093
          // if the page is RAQ, CAD, or SATD, just set dealerSearchType to zip. These pages no longer use dealer-panel. Thank goodness.
          if (dealerSearchType === 'zip' && dealerSearchField.val() !== '' && dealerSearchField.val().length === 5 && dealerSearchField.hasClass('ui-state-valid')) {
            dealerSearchIsValid = true;
          } else if (dealerSearchType === 'state' && dealerSearchField.val() !== '') {
            dealerSearchIsValid = true;
          }
        }

        if (!dealerSearchIsValid) {
          e.preventDefault();
          dealerSearchField.addClass('ui-state-error');
          // $('#search-value').focus();
          $('.js-search-value:visible').focus(); // BAT-4293
          // console.log('Kicking out of SUBMIT!!!!!!!!!!!!');
        } else {
          // if Dealers search page, we do a little more
          if ($('#dealer-search-page').length > 0) {
            // BAT-2044 It's possible to have this element added via 'out of country' (results that contain redirect URLS)
            if ($('#js-dealer-redirect').length > 0) {
              $('#js-dealer-redirect').remove();
            }
            self.$form.addClass('is-loading'); // show is-loading immediately
            setTimeout(function () {
              self.$form.removeClass('show-welcome');
            }, 500);
            $(this).attr('disabled', 'disabled');

            // data-layer, send click events
            // update datalayer with form data
            function updateDataLayer() {
              var $componentToUpdate = $('div[data-component-name="Find-a-Dealer"]');
              var searchTermUsed = $(self.$inputText).val();
              var searchTypeUsed = $(self.$selectSearchType).val();
              var dataToAdd;
              var $clickedElement = $(self.$submit);
              var clickedElementUrl = $clickedElement.attr('href') || $clickedElement.attr('id') || '';
              var fadCompIndex = window.dataLayerBAT.utils.parentCompIndex('Find-a-Dealer');
              dataToAdd = {
                'component_name': 'Find-a-Dealer',
                'component_index': fadCompIndex,
                'component_skin': 'Default',
                'dealer_search_term': searchTermUsed,
                'dealer_search_type': searchTypeUsed,
                'dealer_search_results_count': '0',
                'dealer_search_brand': 'Toyota',
                'link_url': clickedElementUrl,
                'link_href': clickedElementUrl,
                'link_text': window.dataLayerBAT.utils.textTrimmer($clickedElement.text()),
                'link_action': 'AA-link',
                'fireTagShortPhrase': 'aa-link'
              };

              $.extend(window.dataLayerBAT.data, dataToAdd);
            }

            // fire page based km-dealer-search NO MATTER what
            updateDataLayer();
            window.dataLayerBAT.utils.triggerEvent(document, 'DL.CLICK');
          // SLP forms
          } else {
            // aa-link (Find dealer) on SLP FORMS
            var searchTermUsed = $(self.$inputText).val();
            var searchTypeUsed = $(self.$selectSearchType).val();
            var $clickedElement = $(self.$submit);
            var clickedElementUrl = $clickedElement.attr('href') || $clickedElement.attr('id') || '';
            var dataToAdd = {
              'dealer_search_term': searchTermUsed,
              'dealer_search_type': searchTypeUsed,
              'dealer_search_results_count': window.dataLayerBAT.data.dealer_search_results_count || '',
              'dealer_search_brand': 'Toyota',
              'link_url': clickedElementUrl,
              'link_href': clickedElementUrl,
              'link_text': window.dataLayerBAT.utils.textTrimmer($clickedElement.text()),
              'link_action': 'AA-link',
              'fireTagShortPhrase': 'aa-link'
            };

            // we don't actually want the Dealer Block on link click,
            // but since one exists from pageLoad, you may as well update it
            // if the user happened to change their selection
            $.extend(window.dataLayerBAT.data, dataToAdd);
            // wait for results to come in. When they do, DL.SLP_DEALER_RESULTS is triggered
            $(document).off('DL.SLP_DEALER_RESULTS').on('DL.SLP_DEALER_RESULTS', function () {
              window.dataLayerBAT.utils.triggerEvent(document, 'DL.PAGE_LOAD_SUB');
            });


            self.$form.addClass('is-loading');
          }

          var currentPageUrl = window.location.pathname;
          // if (currentPageUrl.indexOf('/dealers') != -1 || $('div#search-type').length > 0) {
          // document.cookie = "find_dealers_bk_val="+$('#search-type').find('select').val()+"!!"+$("#search-value").val()+"; expires=0; path=/";
          // }
          // console.log('SUBMIT BUTTON CLICK!!!!!!')

          // Button should be unhidden after search results return.
          //          $('#slp-submit-button').removeClass('hidden');
          if (dealerSearchType === 'zip') {
            var redirectUrl = null;
            var responseType = '';

            $.ajax({
              dataType: 'json',
              url: '/BATWS/geo/rest/geoLocation/getGeoInfo',
              data: {
                zipcode: dealerSearchField.val(),
                brand: WebStorage.getSessionStorage().getItem('brand')
              },
              success: function (data, textStatus, xhr) {},
              error: function (request, error) {
                responseType = 'xml';
              }
            }).done(function (data) {
              if (data.entityList.length === 0) {
                self.$form.removeClass('is-loading');
                self.$form.find('#search-submit').removeAttr('disabled');
                $('#no-dealers-found').show(0, function () {
                  $('#slp-submit-button').addClass('hidden');
                  $('.row.preferred-dealer-list-item').remove();// remove existing results
                  $('#search-more-button').hide();// remove existing results
                });
              }

              if (data.serviceError != null) {
                redirectUrl = null; // a new serviceError has been returned, reset global redirectUrl
                // check for redirectUrls
                // var newZip = $('#search-value').val();
                var newZip = $('.js-search-value:visible').val(); // BAT-4293
                if (data.serviceError != null && data.serviceError.redirect != null && data.serviceError.redirect.redirectUrl != null ||
                  data.serviceError != null && data.serviceError.Redirect != null && data.serviceError.Redirect.redirectUrl != null) {
                  redirectUrl = data.serviceError.redirect.redirectUrl;
                  zipTools.showDealerRedirectModal(newZip, redirectUrl, inlineModal);
                  return false;

                // check for Virgin Islands
                } else if (zipTools.checkVirginIslands(newZip)) {
                  zipTools.showDealerRedirectModal(newZip, 'http://www.toyotavi.com', inlineModal);
                  return false;
                }
              } else {
                self.submitSearch(true);
              }
            }).fail(function (jqXHR, textStatus, errorThrown) {
              // console.log('ERROR');
              // console.log(textStatus, errorThrown);
              $('#service-error-modal').modal('show');
            });
          } else {
            self.submitSearch(true);
          }
        }
      });

      var zipParam = getParameterByName('zipcode');
      var dealerNameParam = getParameterByName('dealerName');
      var stateParam = getParameterByName('state');
      var miraiParam = getParameterByName('mirai');
      var deepLinkParam = getParameterByName('deep');
      var deepLinkHashFromCookie = JSON.parse(cookies.getItem('dealerSearchDeep'));
      if (miraiParam) {
        $('#mirai-dealer-check').prop('checked', true);
      }
      if (zipParam) {
        $('form.m-dealer-search').removeClass('show-welcome');
        self.$selectSearchType.val('zip').trigger('change').dropkick('refresh');
        self.$inputText.removeAttr('data-storage').val(zipParam); // remove data-storage attr so its not affected by updateZipFields in zip-tools.js
        self.initSetSearchType('zip');
        self.submitSearch(true);

      // autosubmit dealerName search
      } else if (dealerNameParam) {
        $('form.m-dealer-search').removeClass('show-welcome');
        self.$selectSearchType.val('dealerName').trigger('change').dropkick('refresh');
        self.$inputText.removeAttr('data-storage').val(dealerNameParam); // remove data-storage attr so its not affected by updateZipFields in zip-tools.js
        $('.js-search-type-dealer').hide();
        $('.js-search-type-zip').show();
        self.$inputText.next('.input-group-addon').addClass('addon-hidden');

        self.initSetSearchType('dealerName');
        self.dealerSearch();

      // autosubmit state search
      } else if (stateParam) {
        $('form.m-dealer-search').removeClass('show-welcome');
        self.$selectSearchType.val('state').trigger('change').dropkick('refresh');
        self.$inputText.removeAttr('data-storage').val(stateParam); // remove data-storage attr so its not affected by updateZipFields in zip-tools.js
        self.initSetSearchType('state');
        self.submitSearch(true);

      // deepLink searches
      } else if (deepLinkParam && (deepLinkHashFromCookie != null)) {
        $('form.m-dealer-search').removeClass('show-welcome');
        // we have a deepLinkParam, let's pull it out of our cookie and use it for our search type of "deep"
        // update each property of our exisiting deepLinkHash with those from cookie
        self.deepLinkHash.end = deepLinkHashFromCookie.end; // store the hash on this search
        self.deepLinkHash.query = deepLinkHashFromCookie.query; // store the hash on this search
        self.deepLinkHash.queryText = deepLinkHashFromCookie.queryText; // store the hash on this search
        self.deepLinkHash.type = deepLinkHashFromCookie.type; // store the hash on this search
        var queryText = '';
        // TODO: If only PMA results were showing at time of cookie creation, then we don't need to do a deep link
        // switch DEEP search types only
        switch (self.deepLinkHash.type) {
          case 'zip':
            self.$selectSearchType.val('zip').dropkick('refresh');
            queryText = deepLinkHashFromCookie.query;
            break;
          case 'state':
            self.$selectSearchType.val('state').dropkick('refresh');
            self.$selectSearchType.trigger('change');
            queryText = deepLinkHashFromCookie.queryText;
            break;
          case 'dealerName':
            self.$selectSearchType.val('dealerName').dropkick('refresh');
            self.$selectSearchType.trigger('change');
            queryText = deepLinkHashFromCookie.query;
            break;
          default: break;
        }
        // remove data-storage attribute from zip field to prevent zip-tools.js from filling our input w/ the default zip
        // note. Entire attr needs to be removed. NOT just .data('storage')
        self.$inputText.attr('data-storage', '');
        self.$inputText.val(queryText);
        self.initSetSearchType('deep');
        self.dealerSearch();
      // autosubmit dealerName search
      } else {
        self.$selectSearchType.val('zip');
        // check if we have a dealer code we should load instead of the search form
        if (self.displayDealerCode) {
          self.searchPMADealers(self.displayDealerCode);
          $('#slp-submit-button').removeClass('hidden');
        } else if (self.autoSearch === true) {
          setTimeout(function () {
            self.submitSearch(false);
          }, 1000);
        }
      }
    }, // END init

    submitSearch: function (isUserSubmitted) {
      // console.log(WebStorage.getSessionStorage().getItem('series'));
      var self = this;
      var currentZip;
      self.initialLoad = false;
      if (!isUserSubmitted) {
        currentZip = zip.getCookiedDefaultFallback();
        var currentPageUrl = window.location.pathname;
        if (currentPageUrl.indexOf('/dealers') != -1 || $('div#search-type').length > 0) {
          // dealer search page was auto-submitted
          // BAT-2044 It's possible to have this element added via 'out of country' (results that contain redirect URLS)
          if ($('#js-dealer-redirect').length > 0) {
            $('#js-dealer-redirect').remove();
          }
          // if (findDealerCookieVal != null) {
          // var splitCookieVal = findDealerCookieVal.split('!!');
          // self.searchType = splitCookieVal[0];
          // } else {
          self.searchType = 'zip';
          // }
        } else {
          self.searchType = 'zip';
        }
      } else {
        window.bat.util.loader.showLoader();
        var currentPageUrl = window.location.pathname;
        // dealer search type is diff on SLP forms
        var dealerSearchType;
        if ($('#dealer-search-page').length > 0) {
          dealerSearchType = self.searchType;
        // SLP Forms
        } else {
          dealerSearchType = $('select#search-type').val();
          if (!dealerSearchType) {
            // just to be on the safe side, as a result of
            // removing select#search-type for BAT-4093
            if ($('#schedule-test-drive').length > 0 || $('#request-a-quote').length > 0 || $('#contact-a-dealer').length > 0) {
              dealerSearchType = 'zip';
            }
          }
        }

        // console.log('Search Type Div ', $('div#search-type').length);
        if (currentPageUrl.indexOf('/dealers') != -1 || $('div#search-type').length > 0) {
          self.searchType = dealerSearchType;
          if (self.searchType == null || self.searchType == '' || self.searchType == 'undefined' || $.trim(self.searchType) == '' || typeof self.searchType === 'undefined') {
            self.searchType = $('#search-type').val();
          }
        } else {
          self.searchType = dealerSearchType;
        }
        if (self.searchType == null || self.searchType == '' || self.searchType == 'undefined' || $.trim(self.searchType) == '' || typeof self.searchType === 'undefined') {
          self.searchType = 'zip';
        }
      }
      // reset the counter on new form submission
      self.searchCount = 1;

      // reset pagination states
      self.currentResultNum = 1;
      self.resultEndNum = self.maxResults;

      if (self.$searchMoreBtn && self.$searchMoreBtn.length) {
        if (self.$searchMoreBtn.attr('disabled') == 'disabled') {
          self.$searchMoreBtn.html(self.$searchMoreBtn.data('copy')).removeAttr('disabled');
        }
        // remove any pending search data on new form submission
        self.$searchMoreBtn.removeData('pendingSearchData');
      }
      if (self.$searchLessBtn && self.$searchLessBtn.length) {
        this.$searchLessBtn.attr('disabled', 'disabled');
      }
      // console.log('Search Type: ' + self.searchType);
      self.initSetSearchType(self.searchType);

      if (self.searchType === 'zip' && !self.skipGlobalChangeZip) {
        // if search zip is not current zip, go through changeZip process, on SATD, RAQ, CAD pages
        if (currentZip !== self.service.zip.params.zipcode || 'WWW' === tdaConfig.tda.code) {
          // change zip or redirect to new TDA
          if ($('#schedule-test-drive').length > 0 || $('#request-a-quote').length > 0 || $('#contact-a-dealer').length > 0) {
            var responseType = '';
            var newTDACode = tdaConfig.tda.code;
            $.ajax({
              dataType: 'json',
              url: '/BATWS/geo/rest/geoLocation/getGeoInfo',
              data: {
                zipcode: self.service.zip.params.zipcode,
                brand: WebStorage.getSessionStorage().getItem('brand')
              },
              success: function (data, textStatus, xhr) {},
              error: function (request, error) {
                responseType = 'xml';
              }
            }).done(function (data) {
              // if no dealers returned
              if (data.entityList.length === 0) {
                // check for redirectUrls
                var newZip = self.service.zip.params.zipcode;
                if (data.serviceError != null && data.serviceError.redirect != null && data.serviceError.redirect.redirectUrl != null ||
                  data.serviceError != null && data.serviceError.Redirect != null && data.serviceError.Redirect.redirectUrl != null) {
                  redirectUrl = data.serviceError.redirect.redirectUrl;
                  zipTools.showDealerRedirectModal(newZip, redirectUrl, false);
                } else if (zipTools.checkVirginIslands(newZip)) {
                  // check for Virgin Islands
                  zipTools.showDealerRedirectModal(newZip, 'http://www.toyotavi.com', false);
                } else {
                  var $noDealersText = $('#no-dealers-found', self.$form);
                  self.$form.find('#search-submit').removeAttr('disabled');
                  $noDealersText.show(0, function () {
                    $('#slp-submit-button').addClass('hidden');
                    $('.row.preferred-dealer-list-item').remove();// remove existing results
                    $('#search-more-button').hide();// remove existing results
                  });
                }
                self.$form.removeClass('is-loading');
                return false;
              }

              newTDACode = data.entityList[0].tdaCode;
              if (tdaConfig.tda.code === 'WWW') {
                tdaCodeForDealerSearch = newTDACode;
              }
              if ((tdaConfig.tda.code === newTDACode && $('input[data-storage="userZip"]').val() !== '') || tdaConfig.tda.code === 'WWW') {
                if ($('#find-dealer-method').val() !== '') {
                  $('#find-dealer-method').removeClass('ui-state-error');
                  self.$form.removeClass('is-loading');
                  self.dealerSearch();
                } else {
                  self.$form.removeClass('is-loading');
                  $('#find-dealer-method').addClass('ui-state-error');
                }
              } else {
                if ($('#find-dealer-method').val() !== '') {
                  zipTools.changeZip(currentZip, self.service.zip.params.zipcode, self.zipRedirectPath, function (newZip) {
                    $('#find-dealer-method').removeClass('ui-state-error');
                    // self.$form.addClass('is-loading');
                    if (self.panelSearch) {
                      self.dealerSearch();
                    }
                  });
                } else {
                  $('#find-dealer-method').addClass('ui-state-error');
                }
              }
            });
          } else {
            zipTools.changeZip(currentZip, self.service.zip.params.zipcode, self.zipRedirectPath, function (newZip) {
              if (self.panelSearch) {
                self.dealerSearch();
              }
            });
          }
        } else {
          // just submit the form since it's for current zip
          self.dealerSearch();
        }
      } else if (self.searchType === 'state') {
        var address = self.$inputText.val();

        var failCallback = function () {
          alert('failed');
        };

        zipTools.getLatLongFromAddress(address, function (lat, longitude) {
          // console.log('Lat/Long: ' + lat + ' : ' + longitude);
          zipTools.getZipFromLatLong(lat, longitude, function (zip) {
            // console.log('calculated State zip: ' + zip);
            self.service.state.params.zipcode = zip;
            zipCodeForDealerSearch = self.service.state.params.zipcode;
            if (!self.skipGlobalChangeZip && (currentZip !== self.service.state.params.zipcode)) {
              if ($('#schedule-test-drive').length > 0 || $('#request-a-quote').length > 0 || $('#contact-a-dealer').length > 0) {
                var responseType = '';
                var newTDACode = tdaConfig.tda.code;
                $.ajax({
                  dataType: 'json',
                  url: '/BATWS/geo/rest/geoLocation/getGeoInfo',
                  data: {
                    zipcode: self.service.state.params.zipcode,
                    brand: WebStorage.getSessionStorage().getItem('brand')
                  },
                  success: function (data, textStatus, xhr) {},
                  error: function (request, error) {
                    responseType = 'xml';
                  }
                }).done(function (data) {
                  var totalDealerCount = 0;
                  var $noDealersText = $('#no-dealers-found', self.$form);
                  if ($noDealersText.is(':visible')) {
                    $noDealersText.hide();
                  }
                  // if no dealers returned
                  if (data.entityList.length === 0) {
                    var newZip = self.service.state.params.zipcode;

                    if (data.serviceError != null && data.serviceError.redirect != null && data.serviceError.redirect.redirectUrl != null ||
                      data.serviceError != null && data.serviceError.Redirect != null && data.serviceError.Redirect.redirectUrl != null) {
                      redirectUrl = data.serviceError.redirect.redirectUrl;
                      zipTools.showDealerRedirectModal(newZip, redirectUrl, false);

                    // check for Virgin Islands
                    } else if (zipTools.checkVirginIslands(newZip)) {
                      // new global redirectu URL is set in checkVirginIslands
                      zipTools.showDealerRedirectModal(newZip, 'http://www.toyotavi.com', false);
                    } else {
                      var $noDealersText = $('#no-dealers-found', self.$form);
                      self.$form.find('#search-submit').removeAttr('disabled');
                      $noDealersText.show(0, function () {
                        $('#slp-submit-button').addClass('hidden');
                        $('.row.preferred-dealer-list-item').remove();// remove existing results
                        $('#search-more-button').hide();// remove existing results
                      });
                    }

                    self.$form.removeClass('is-loading');
                    return false;
                  }

                  newTDACode = data.entityList[0].tdaCode;
                  if (tdaConfig.tda.code === 'WWW') {
                    tdaCodeForDealerSearch = newTDACode;
                  }
                  if ((tdaConfig.tda.code === newTDACode && $('#headerZipInput').val() !== '') || tdaConfig.tda.code === 'WWW') {
                    if ($('#find-dealer-method').val() !== '') {
                      $('#find-dealer-method').removeClass('ui-state-error');
                      self.$form.addClass('is-loading');
                      self.dealerSearch();
                    } else {
                      $('#find-dealer-method').addClass('ui-state-error');
                    }
                  } else {
                    if ($('#find-dealer-method').val() !== '') {
                      $('#find-dealer-method').removeClass('ui-state-error');
                      zipTools.changeZip(currentZip, self.service.state.params.zipcode, self.zipRedirectPath, function (newZip) {
                        // BAT-3473 - Cancelling redirect modal was resulting in out-of-TDA leads
                        // if WWW, and if panelSearch = true, do the dealer search and remove
                        // the loading class (once the code gets to this point this should
                        // not happen anyway)
                        if (tdaConfig.tda.code === 'WWW' && self.panelSearch) {
                          self.dealerSearch();
                          self.$form.removeClass('is-loading');
                        }
                      });
                    } else {
                      $('#find-dealer-method').addClass('ui-state-error');
                      self.$form.removeClass('is-loading');
                    }
                  }
                });
              } else {
                // change zip or redirect to new TDA
                zipTools.changeZip(currentZip, self.service.state.params.zipcode, self.zipRedirectPath, function (newZip) {
                  self.$form.addClass('is-loading');
                  $('#search-result-wrap').removeClass('view-results-visible');
                  // console.log("Submitting search");
                  self.dealerSearch();
                });
              }
            } else {
              self.$form.addClass('is-loading');
              $('#search-result-wrap').removeClass('view-results-visible');
              // console.log("Submitting search");
              self.dealerSearch();
            }
          });
        }, failCallback);
      } else {
        // not a zip search
        // console.log("In function that has just submit");
        self.$form.addClass('is-loading').removeClass('show-welcome');
        $('#search-result-wrap').removeClass('view-results-visible');
        self.dealerSearch();
      }
    }, // END submitSearch


    /**
     * This function does a search from a deep link zip code (no need to have verified zip).
     * as of BAT25-58 (July 20, 2017) - deepLinkZipSearch is no longer in use.
     * since we allow ANY ZIP search on the FAD page, w/out changing TDAs, we do not need  deepLinkZipSearch
     * Also, until BAT25-58 came along, we didn't have any /dealers/?zipcode links in place anyway.
     */
    deepLinkZipSearch: function (zip) {
      var self = this;

      // console.debug('in deepLinkZipSearch: ' + zip);
      var oldZip = self.$inputText.val();
      // console.debug('old zip: ' + oldZip);

      // reset the counter on new form submission
      self.searchCount = 1;

      // reset pagination states
      self.currentResultNum = 1;
      self.resultEndNum = self.maxResults;

      if (self.$searchMoreBtn && self.$searchMoreBtn.length) {
        if (self.$searchMoreBtn.attr('disabled') == 'disabled') {
          self.$searchMoreBtn.html(self.$searchMoreBtn.data('copy')).removeAttr('disabled');
        }
        // remove any pending search data on new form submission
        self.$searchMoreBtn.removeData('pendingSearchData');
      }

      self.initSetSearchType('zip');

      if (zip == oldZip) {
        self.$form.addClass('is-loading');
        // console.debug('zip matches, do regular search');
        self.dealerSearch();
      } else {
        // console.debug('zip does not match, do changeZip: ' + self.zipRedirectPath);
        // console.debug('is_pma: ' + self.is_pma);
        zipTools.changeZipForDeepLink(oldZip, zip, self.zipRedirectPath, function (zip) {
          // self.$form.addClass('is-loading');
          if (self.panelSearch) {
            self.dealerSearch();
          }
        });
      }
    }, // END deepLinkZipSearch

    dealerSearch: function () {
      var self = this;
      if (self.$searchMoreBtn && self.$searchMoreBtn.length) {
        this.$searchMoreBtn.attr('disabled', 'disabled').html('Loading&hellip;');
      }
      self.searchAllDealers();
    }, // END dealerSearch

    loadMoreResults: function () {
      var self = this;
      // console.info("In load more results: ", self);
      // console.info("Params: ", self.currentResultNum , " : " , self.resultEndNum);
      self.resultEndNum = self.currentResultNum + self.maxResults - 1;
      // console.log("Params: ", self.currentResultNum, " : ", self.resultEndNum);

      if (self.$searchMoreBtn && self.$searchMoreBtn.length) {
        this.$searchMoreBtn.attr('disabled', 'disabled').html('Loading&hellip;');
      }
      // console.log("Disable Previous?: ", self.currentResultNum, " - ", self.maxResults);
      if (self.currentResultNum - self.maxResults < 1) {
        // console.log("Disabling");
        this.$searchLessBtn.attr('disabled', 'disabled');
      } else {
        // console.log("Enabling");
        self.$searchLessBtn.removeAttr('disabled');
      }
      switch (self.searchType) {
        case 'zip':
          self.service.zip.params.begin = self.currentResultNum;
          self.service.zip.params.end = self.resultEndNum;
          self.service.zip.params.zipcode = self.$inputText.val();
          self.service.zip.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.serviceUrl = self.service.zip.url;
          self.serviceParams = self.service.zip.params;
          break;
        case 'state':
          self.service.state.params.begin = self.currentResultNum;
          self.service.state.params.end = self.resultEndNum;
          self.service.state.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.serviceUrl = self.service.state.url;
          self.serviceParams = self.service.state.params;
          break;
        case 'dealerName':
          self.service.dealerName.params.begin = self.currentResultNum;
          self.service.dealerName.params.end = self.resultEndNum;
          self.service.dealerName.params.dealerName = self.$inputText.val();
          self.service.dealerName.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.service.zip.params.tdaCode = localStorage.tdaCode;
          self.serviceUrl = self.service.dealerName.url;
          self.serviceParams = self.service.dealerName.params;
          break;
        case 'deep':
          var deepQuery = self.deepLinkHash.query || self.$inputText.val();
          self.service.deep.params.begin = self.currentResultNum;
          self.service.deep.params.end = self.resultEndNum;
          self.service.deep.params.zipcode = deepQuery;
          self.service.deep.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.serviceUrl = self.service.deep.url;
          self.serviceParams = self.service.deep.params;
          break;
        default: break;
      }
      self.searchAllDealers();
    }, // END loadMoreResults

    loadLessResults: function (begin, end) {
      var self = this;
      // console.info("In load less results: ", self);
      // console.info("Self: ", self , " :currentNum: ", self.currentResultNum , " :endNum: " , self.resultEndNum, " :max: ", self.maxResults, " :begin: ", begin , " :end: ", end);
      self.resultEndNum = self.serviceParams.begin - 1;
      // console.log("end number", self.resultEndNum);
      self.currentResultNum = self.serviceParams.begin - self.maxResults;


      if (self.$searchLessBtn && self.$searchLessBtn.length) {
        this.$searchLessBtn.attr('disabled', 'disabled');
      }
      switch (self.searchType) {
        case 'zip':
          self.service.zip.params.begin = self.currentResultNum;
          self.service.zip.params.end = self.resultEndNum;
          self.service.zip.params.zipcode = self.$inputText.val();
          self.service.zip.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.serviceUrl = self.service.zip.url;
          self.serviceParams = self.service.zip.params;
          break;
        case 'state':
          self.service.state.params.begin = self.currentResultNum;
          self.service.state.params.end = self.resultEndNum;
          self.service.state.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.serviceUrl = self.service.state.url;
          self.serviceParams = self.service.state.params;
          break;
        case 'dealerName':
          self.service.dealerName.params.begin = self.currentResultNum;
          self.service.dealerName.params.end = self.resultEndNum;
          self.service.dealerName.params.dealerName = self.$inputText.val();
          self.service.dealerName.params.mirai = $('#mirai-dealer-check').prop('checked') || (WebStorage.getSessionStorage().getItem('series') === 'mirai' && $('#dealer-search-page').length <= 0) || false;
          self.serviceUrl = self.service.dealerName.url;
          self.service.dealerName.params.tdaCode = localStorage.tdaCode;
          self.serviceParams = self.service.dealerName.params;
          break;
        default: break;
      }
      self.searchAllDealers();
    }, // END loadLessResults

    transformSearchResultsToTemplateResults: function (searchResults, currentResultCount) {
      var self = this;
      var dealerLocators = [];
      var templateResults = [];
      var currentDay = self.getDay() - 1;
      var i; var j;
      var dealerLocatorsLength;
      var dealerLocator;
      var phone;
      var start;
      var end;
      var proximityMeasure;
      var detailUrlPrefix = ''; // [CAT-357] Prefix to detail url

      if (searchResults.dealerLocator) dealerLocators = searchResults.dealerLocator;

      for (i = 0, dealerLocatorsLength = dealerLocators.length; i < dealerLocatorsLength; i++) {
        dealerLocator = dealerLocators[i];
        // Does dealer have BAT flag
        var programs = dealerLocator.dealerMetaDataDetail.program;
        var bat_flag = true;
        for (j = 0; j < programs.length; j++) {
          if (programs[j].code.value === 'BAT') {
            // console.log("Found bat participation indicator :",programs[j].participationIndicator)
            bat_flag = programs[j].participationIndicator;
            break;
          }
        }

        // console.log("Bat flag: ", bat_flag);
        if (bat_flag === false) {
          // console.log("Continue");
          continue;
        }
        // set initial values
        phone = null;
        start = null;
        end = null;
        proximity_measure = null;

        try {
          phone = dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].telephoneCommunication[0].completeNumber.value;
        } catch (e) {
          console.warn('NO phone');
        }

        $.each(dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].telephoneCommunication, function (index, value) {
          if (value.channelCode.value == 'bat_toll_free' && value.completeNumber.value != null && value.completeNumber.value != '') {
            phone = value.completeNumber.value;
          }
        });

        try {
          start = dealerLocator.dealerLocatorDetail.hoursOfOperation[0].daysOfWeek[currentDay].availabilityStartTimeMeasure.value;
        } catch (e) {
          console.warn('NO START HOURS');
        }

        try {
          end = dealerLocator.dealerLocatorDetail.hoursOfOperation[0].daysOfWeek[currentDay].availabilityEndTimeMeasure.value;
        } catch (e) {
          console.warn('NO END HOURS');
        }

        try {
          proximity_measure = readableMonetize(dealerLocator.dealerLocatorDetail.proximityMeasureGroup.proximityMeasure.value);
        } catch (e) {
          console.warn('NO PROXIMITY MEASURE');
        }

        var dealerUrl = '';
        $.each(dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].uricommunication, function (index, value) {
          if (value.channelCode.value === 'Website') {
            dealerUrl = value.uriid.value;
          }
        });

        var brand = dealerLocator.dealerLocatorDetail.dealerParty.relationshipTypeCode.value;

        // [CAT-357] BEGIN - National needs to render proper dealer-detail links
        var tdaCode = self.getTDACodeFromDealerLocatorResult(dealerLocator);
        if (tdaConfig.tda.code == 'WWW') {
          detailUrlPrefix = '/GOTO/' + tdaCode;
        }
        // [CAT-357] END

        templateResults.push({
          resultCount: currentResultCount + i,
          dealer_code: dealerLocator.dealerId,
          tda_code: tdaCode,
          dealer_detail_url_prefix: detailUrlPrefix, // [CAT-357] Provide redirect prefix on national
          is_pma: self.isDealerLocatorResultPMA(dealerLocator),
          is_mirai: self.isDealerLocatorResultMirai(dealerLocator),
          // is_mirai: true, // TEMP, for testing
          brand: brand.toLowerCase(),
          name: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.companyName.value,
          postalAddress: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.lineOne.value,
          city: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.cityName.value,
          state: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.stateOrProvinceCountrySubDivisionID.value,
          zipCode: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.postcode.value,
          phone: self.phoneNumber(phone),
          // phoneLink:self.phoneNumber(phone, true),
          phoneLink: window.bat.formatPhoneLink(phone),
          hours: self.dealerHours(start, end),
          siteUrl: dealerUrl,
          coords: {
            lat: dealerLocator.dealerLocatorDetail.proximityMeasureGroup.geographicalCoordinate.latitudeMeasure.value,
            lon: dealerLocator.dealerLocatorDetail.proximityMeasureGroup.geographicalCoordinate.longitudeMeasure.value
          },
          proximity_measure: proximity_measure,
          markerConfig: 'scale:2|shadow:false|icon:http://www.buyatoyota.com/assets/img/maps/marker@2x.png',
          dataLayer: {
            dealer_brand: brand.toLowerCase(),
            dealer_code: dealerLocator.dealerId,
            dealer_name: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.companyName.value,
            dealer_zipcode: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.postcode.value,
            dealer_city: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.cityName.value,
            dealer_state: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.stateOrProvinceCountrySubDivisionID.value,
            dealer_metro: dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.divisionCode.name
          }
        });
      }
      return templateResults;
    }, // END transformSearchResultsToTemplateResults

    searchPMADealers: function (dealerCode) {
      var self = this;
      var brand = WebStorage.getSessionStorage().getItem('brand');
      $.ajax({
        dataType: 'json',
        url: '/BATWS/geo/rest/filterMode/getDealerDetails',
        data: {
          dealerCode: dealerCode,
          brand: brand,
          begin: 1,
          // current logic makes one request per dealer code
          end: 1
          // end: dealerCodes.length
        },
        beforeSend: function (xhrObj) {
          xhrObj.setRequestHeader('Content-Type', 'application/json');
          xhrObj.setRequestHeader('Accept', 'application/json');
          xhrObj.overrideMimeType('application/json');
        }
      }).done(function (data) {
        self.$form.removeClass('is-loading');

        // transform data to template results and do on search complete
        self.onSearchComplete(self.transformSearchResultsToTemplateResults(data, self.searchCount));

        // increment searchCount
        if (data.dealerLocator) self.searchCount += data.dealerLocator.length;
      }).fail(function (jqXHR, textStatus, errorThrown) {
        // console.log('ERROR');
        // console.log(textStatus, errorThrown);
        self.handleServiceError();
      });
    }, // END searchPMADealers

    searchAllDealers: function () {
      var self = this;
      // console.log("Searching Dealers: ", self.serviceParams);
      // console.log('Url ', self.serviceUrl);
      // console.log('Params ', self.serviceParams);
      var totalDealerCount = 0;
      var $noDealersText = $('#no-dealers-found', self.$form);
      if ($noDealersText.is(':visible')) {
        $noDealersText.hide();
      }

      self.$form.addClass('is-loading');

      if (tdaConfig.tda.code === 'WWW') {
        var tdaCodeFromParam = getParameterByName('tdaCode');
        if (tdaCodeFromParam) {
          self.service.zip.params.tdacode = tdaCodeFromParam;
        } else {
          self.service.zip.params.tdacode = tdaCodeForDealerSearch;
        }
      }

      if (window.location.pathname.indexOf('dealer-directory') != -1) {
        $.ajax({
          dataType: 'json',
          url: self.serviceUrl,
          data: self.serviceParams,
          beforeSend: function (xhrObj) {
            xhrObj.setRequestHeader('Content-Type', 'application/json');
            xhrObj.setRequestHeader('Accept', 'application/json');
            xhrObj.overrideMimeType('application/json');
          }
        }).done(function (data) {
          totalDealerCount = data.dealerCount;
          self.serviceParams.end = totalDealerCount;
          $.ajax({
            dataType: 'json',
            url: self.serviceUrl,
            data: self.serviceParams,
            beforeSend: function (xhrObj) {
              xhrObj.setRequestHeader('Content-Type', 'application/json');
              xhrObj.setRequestHeader('Accept', 'application/json');
              xhrObj.overrideMimeType('application/json');
            }
          }).done(function (data) {
            // console.log("dealer count:", data.dealerCount);
            // transform data to template results and do on search complete
            self.onSearchComplete(self.transformSearchResultsToTemplateResults(data, self.searchCount));
            // console.log("search count:", self.searchCount);

            // increment searchCount
            if (data.dealerLocator) self.searchCount += data.dealerLocator.length;
            // console.log("incremented search count:", self.searchCount);

            // after search, adjust start index
            self.currentResultNum = self.searchCount;
            // self.currentResultNum = self.currentResultNum + self.maxResults;
            // console.log("current result number:", self.currentResultNum);

            self.$form.removeClass('is-loading');
          }).fail(function (jqXHR, textStatus, errorThrown) {
            // console.log('ERROR');
            // console.log(textStatus, errorThrown);
            self.handleServiceError();
          });
        }).fail(function (jqXHR, textStatus, errorThrown) {
          // console.log('ERROR');
          // console.log(textStatus, errorThrown);
          self.handleServiceError();
          self.$form.removeClass('is-loading');
        });
      } else {
        $.ajax({
          dataType: 'json',
          url: self.serviceUrl,
          data: self.serviceParams,
          beforeSend: function (xhrObj) {
            xhrObj.setRequestHeader('Content-Type', 'application/json');
            xhrObj.setRequestHeader('Accept', 'application/json');
            xhrObj.overrideMimeType('application/json');
          }
        }).done(function (data) {
          // Save our response data since we hide many attributes in the
          // transformation process.  This exposes it for others to consume
          // out of the limited scope of this function.
          self.lastResponseData = data;

          // BAT-2044 our of country dealer 'modal', if response contains a redirectUrl
          if ($('#dealer-search-page').length > 0) {
            var inlineModal = true;
          } else {
            var inlineModal = false;
          }

          if (data.serviceError.length > 0) {
            // check for redirectUrls
            var newZip = self.serviceParams.zipcode;
            // why is this the only time that data.serviceError is an array?
            if (data.serviceError[0].redirect != null && data.serviceError[0].redirect.redirectUrl != null) {
              redirectUrl = data.serviceError[0].redirect.redirectUrl;
              zipTools.showDealerRedirectModal(newZip, redirectUrl, inlineModal);
            } else if (data.serviceError[0].Redirect != null && data.serviceError[0].Redirect.redirectUrl != null) {
              redirectUrl = data.serviceError[0].Redirect.redirectUrl;
              zipTools.showDealerRedirectModal(newZip, redirectUrl, inlineModal);

            // check for Virgin Islands
            } else if (zipTools.checkVirginIslands(newZip)) {
              zipTools.showDealerRedirectModal(newZip, 'http://www.toyotavi.com', inlineModal);
            } else {
              var $noDealersText = $('#no-dealers-found', self.$form);
              self.$form.find('#search-submit').removeAttr('disabled');
              $noDealersText.show(0, function () {
                $('#slp-submit-button').addClass('hidden');
                $('.row.preferred-dealer-list-item').remove();// remove existing results
                $('#search-more-button').hide();// remove existing results
              });
            }

            self.$form.removeClass('is-loading');
            $('.js-results-present').css('opacity', '1');
            window.bat.util.loader.hideLoader();
            return false;
          }

          self.$form.removeClass('is-loading');
          // console.group('searchAllDealers done');
          // console.log('self: ', self);
          // console.log('self.currentResultNum: ', self.currentResultNum);
          // console.log('self.maxResults: ', self.maxResults);
          // console.log('added together: ', self.currentResultNum + self.maxResults);
          // console.log('dealer count: ', data.dealerCount);

          // set will be disabled attribute on search more button (for dealer search showing PMA dealers only initially)
          if (self.$searchMoreBtn && self.$searchMoreBtn.length) {
            // console.log('There is a searchMoreBtn, set isDisabledPending to true');
            self.$searchMoreBtn.data('isDisabledPending', true);
            if (data.dealerCount && data.dealerCount >= (self.currentResultNum + self.maxResults)) {
              // console.log('isDisabledPending to false');
              self.$searchMoreBtn.data('isDisabledPending', false);
            }

            // if deep link and data.dealerCount <= self.deepLinkHash.end
            if (self.searchType === 'deep' && (data.dealerCount <= self.deepLinkHash.end)) {
              // console.log('isDisabledPending to true, within deepLink');
              self.$searchMoreBtn.data('isDisabledPending', true);
            }
          }
          // console.groupEnd();

          // transform data to template results and do on search complete
          self.onSearchComplete(self.transformSearchResultsToTemplateResults(data, self.searchCount));
          // console.group('searchAllDealers onSearchComplete done');
          // console.log('search count: ', self.searchCount);

          // increment searchCount
          if (data.dealerLocator) {
            self.searchCount += data.dealerLocator.length;
          }
          // after search, adjust start index
          self.currentResultNum = self.searchCount;
          // console.log('incremented search count: ', self.searchCount);
          // console.log('current result number: ', self.currentResultNum);


          if (self.$searchMoreBtn && self.$searchMoreBtn.length) {
            // console.log('there is a searchMoreBtn');
            if (self.$searchMoreBtn.attr('disabled') === 'disabled') {
              self.$searchMoreBtn.html(self.$searchMoreBtn.data('copy'));
              // console.log('it is disabled');
              // requires self.currentResultNum to be incremented above
              if (data.dealerCount && data.dealerCount >= self.currentResultNum) {
                // console.log('and now it is enabled');
                self.$searchMoreBtn.removeAttr('disabled');
              }
            }
          }
          // console.groupEnd();
        }).fail(function (jqXHR, textStatus, errorThrown) {
          // console.log('ERROR');
          // console.log(textStatus, errorThrown);
          self.handleServiceError();
        });
      }
    }, // END searchAllDealers

    handleServiceError: function () {
      $('#service-error-modal').modal('show');
    }, // END handleServiceError

    phoneNumber: function (val) {
      if (val != null) {
        return val.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '($1) $2-$3');
      }
    }, // END phoneNumber

    dealerHours: function (start, end) {
      if (start != null && end != null) {
        return this.formatTime(start) + ' - ' + this.formatTime(end);
      } else {
        return 'Contact Dealer';
      }
    }, // END dealerHours

    formatTime: function (val) {
      var hours = Math.floor(val / 60);
      var ampm = (hours < 12) ? 'am' : 'pm';
      if (hours == 0) {
        hours = 12;
      } else if (hours > 12) {
        hours = hours - 12;
      }

      var minutes = val % 60;

      if (minutes > 0) {
        return hours + ':' + minutes + ampm;
      } else {
        return hours + ampm;
      }
    }, // END formatTime

    getDay: function () {
      var date = new Date();
      var day = date.getDay();
      return day;
    }, // END getDay

    getTDACodeFromDealerLocatorResult: function (dealerLocatorResult) {
      var organizationGrepResults = [];
      var organization;
      var party;
      var tdaCode;

      if (dealerLocatorResult && dealerLocatorResult.dealerMetaDataDetail && dealerLocatorResult.dealerMetaDataDetail.organization) {
        organizationGrepResults = $.grep(dealerLocatorResult.dealerMetaDataDetail.organization, function (element, index) {
          // return the organization with type TDA
          if (element.organizationType) return element.organizationType.value == 'TDA';
        });

        if (organizationGrepResults.length) {
          organization = organizationGrepResults[0];

          if (organization.party.length) {
            party = organization.party[0];

            if (party.specifiedOrganization && party.specifiedOrganization.companyCode) {
              tdaCode = party.specifiedOrganization.companyCode.value;
            }
          }
        }
      }

      return tdaCode;
    },

    isDealerLocatorResultPMA: function (dealerLocatorResult) {
      var programGrepResults = [];
      var program;
      var isPMA;

      if (dealerLocatorResult && dealerLocatorResult.dealerMetaDataDetail && dealerLocatorResult.dealerMetaDataDetail.program) {
        programGrepResults = $.grep(dealerLocatorResult.dealerMetaDataDetail.program, function (element, index) {
          // return the program with code TDA
          if (element.code) return element.code.value == 'PMA';
        });

        if (programGrepResults.length) {
          program = programGrepResults[0];

          isPMA = program.participationIndicator;
        }
      }

      if (window.location.pathname.indexOf('dealer-directory') != -1) {
        $('#search-more-dealers').hide();
        return true;
      } else {
        return isPMA;
      }
    },

    isDealerLocatorResultMirai: function (dealerLocatorResult) {
      var programGrepResults = [];
      var program;
      var isMirai;

      if (dealerLocatorResult && dealerLocatorResult.dealerMetaDataDetail && dealerLocatorResult.dealerMetaDataDetail.additionalService) {
        programGrepResults = $.grep(dealerLocatorResult.dealerMetaDataDetail.additionalService, function (element, index) {
          // return the additionalService with code TDA
          if (element.code) return element.code.value == 'MiraiSales';
        });

        if (programGrepResults.length) {
          program = programGrepResults[0];

          isMirai = program.participationIndicator;
        }
        // console.log('isMirai: ', isMirai);
      }

      if (window.location.pathname.indexOf('dealer-directory') != -1) {
        $('#search-more-dealers').hide();
      }

      return isMirai;// BAT-3077
    }
  }; // END DealerPanel prototype

  // Shim
  // window.bat.DealerPanel = DealerPanel;
  return DealerPanel;
});

